import { Link } from "react-router-dom";
import { useQuote } from "@/lib/quote";

export default function ProductCard({ item, priority = false }) {
  const { addItem, setDrawerOpen } = useQuote();
  const isService = !!item.service_slug;
  const target = isService ? `/services/${item.service_slug}` : `/shop/${item.slug}`;
  const comingSoon = (item.availability_note || "").startsWith("Coming soon");
  const ctaLabel = isService ? (comingSoon ? "Ask About Future Availability" : "Request Availability") : "Add to My Quote";

  const onAdd = () => {
    if (isService) return;
    addItem(item);
    setDrawerOpen(true);
  };

  return (
    <article className="group flex h-full flex-col" data-testid={`product-card-${item.slug}`}>
      <Link to={target} className="mat-frame block transition-colors duration-500 group-hover:border-gilt/60" aria-label={item.title}>
        <div className="overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            loading={priority ? "eager" : "lazy"}
            className="aspect-[4/5] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
            width="600"
            height="750"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col px-1 pt-5">
        <p className="text-[11px] uppercase tracking-widest2 text-smoke">{item.category}</p>
        <h3 className="mt-1.5 font-display text-2xl font-light leading-snug text-ink">
          <Link to={target} className="transition-colors hover:text-olive">
            {item.title}
          </Link>
        </h3>
        <p className="mt-1.5 text-[12px] uppercase tracking-[0.14em] text-stone">
          {comingSoon
            ? "Coming soon · Interest only"
            : isService
              ? "Staffed service · Availability confirmed in your proposal"
              : `${item.unit} · Pricing confirmed in your proposal`}
        </p>
        <div className="mt-auto pt-5">
          {isService ? (
            <Link
              to={target}
              data-testid={`service-cta-${item.slug}`}
              className={`block w-full py-3 text-center text-[12px] uppercase tracking-[0.18em] transition-colors duration-300 ${
                comingSoon
                  ? "border border-olive/50 text-olive hover:bg-olive hover:text-ivory"
                  : "border border-ink/25 text-ink hover:border-olive hover:bg-olive hover:text-ivory"
              }`}
            >
              {ctaLabel}
            </Link>
          ) : (
            <button
              data-testid={`add-to-quote-${item.slug}`}
              onClick={onAdd}
              className="w-full border border-ink/25 py-3 text-[12px] uppercase tracking-[0.18em] text-ink transition-colors duration-300 hover:border-olive hover:bg-olive hover:text-ivory"
            >
              Add to My Quote
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
